import * as React from 'react'

const Page = ({ children, className }) => (
  <div
    className={`w-content max-w-full h-screen min-h-[640px] p-4 ${className}`}
  >
    {children}
  </div>
)

export default Page
